import { E as e, V as t, a as n, d as r, g as i, i as a, m as o, n as s, o as c, r as l, t as u, u as d } from "./useCollections-CUHBsxWQ.js";
import { t as f } from "./sourceConversations-DveaTklB.js";
import { n as p, r as m, t as h } from "./useNotification-BA0yx-Cj.js";
import { ApolloProvider as g, gql as _, useApolloClient as v } from "@apollo/client";
import { Avatar as y, Badge as b, Box as x, Button as S, Chip as C, DropdownButton as w, FieldSelect as T, FlexBox as E, Icon as D, Modal as O, ModalFoot as k, ModalHead as A, Text as j, Timestamp as M, Tooltip as N } from "@dixa/lib-shared-habla";
import { jsx as P, jsxs as F } from "react/jsx-runtime";
import { forwardRef as I, useMemo as L, useState as R } from "react";
import z from "classnames";
import { ampli as B } from "lib-shared-tracking";
import { useHasAccess as V } from "lib-shared-access-control";
// ../management-common/src/utils/translations.ts
function H(e, t = a.En) {
	return e.find((e) => e.languageId === t)?.title || `${e[0].title}`;
}
// ../management-common/src/utils/categoryDropdownItems.ts
var U = ({ currentCategoryId: e, disabledCategoryIds: t }) => (n, r) => {
	let i = r.id === e || t.includes(r.id), a = H(r.titles);
	return n.listItems.push({
		disabled: i,
		id: r.id,
		type: r.__typename,
		name: a,
		nestLevel: n.nestLevel
	}), !i && r.categories?.reduce(U({
		disabledCategoryIds: t,
		currentCategoryId: e
	}), {
		listItems: n.listItems,
		nestLevel: n.nestLevel + 1
	}), n;
};
function W({ categories: e, currentCategoryId: t, disabledCategoryIds: n, withCollectionOption: r, collectionId: i }) {
	if (!i) throw Error("collectionId is required");
	let a = e.reduce(U({
		currentCategoryId: t,
		disabledCategoryIds: n
	}), {
		listItems: r ? [{
			name: "None",
			type: "Collection",
			id: i,
			disabled: !1,
			nestLevel: -1
		}] : [],
		nestLevel: 0
	}).listItems;
	return {
		listItems: a.map((e) => ({
			id: e.id,
			name: K(e.name, e.nestLevel)
		})),
		allDisabledCategoryIds: a.filter((e) => e.disabled).map((e) => e.id)
	};
}
var G = "\xA0\xA0\xA0\xA0";
function K(e, t) {
	return `${Array.from({ length: t }).map(() => G).join("")}${e}`;
}
// ../management-common/src/components/categoryTreeInput/categoryDropdown.tsx
var q = ({ collectionId: e, value: t, onChange: n, onToggle: r, withCollectionOption: i, currentCategoryId: a, disabledCategoryIds: o = [], required: s, touched: c = !1, placeholder: l, label: u, className: f, disabled: p }) => {
	let [m, h] = R(!1), { data: g, loading: _ } = d({
		variables: { collectionId: e },
		skip: !m
	}), v = (t) => {
		e && t && n(t === e ? {
			__typename: "Collection",
			id: e
		} : {
			__typename: "Category",
			id: t
		});
	}, { allDisabledCategoryIds: y, listItems: b } = W({
		categories: g?.collection?.categories || (t?.__typename === "Category" ? [t].filter(Boolean) : []),
		withCollectionOption: i,
		currentCategoryId: a,
		disabledCategoryIds: o,
		collectionId: e
	});
	return /* @__PURE__ */ P(T, {
		disabled: p || _,
		searchable: !0,
		className: f,
		label: u,
		noLabel: !u,
		required: s,
		onToggle: (e) => {
			h(e), r?.(e);
		},
		input: {
			name: "categoryDropdown",
			value: t?.id ? [t.id] : [],
			onChange: v
		},
		meta: {
			error: s && !t?.id ? "Category is required" : void 0,
			touched: c
		},
		disabledItems: y,
		items: _ ? [] : b,
		placeholder: _ ? "Loading Categories..." : l
	});
}, J = { categoryTreeInput: "_categoryTreeInput_1dov9_1" }, Y = ({ value: e, onChange: t, withCollectionOption: n, currentCategoryId: r, disabledCategoryIds: i = [], collectionId: a, required: o, label: s = "Parent Category", placeholder: c, disabled: l }) => {
	let { cache: u } = v(), d = e?.__typename === "Category" ? u.readFragment({
		id: `Category:${e?.id}`,
		fragment: _`
            fragment CategoryTitles on Category {
              id
              titles {
                title
                languageId
              }
            }
          `
	}) : e;
	return a ? /* @__PURE__ */ P(q, {
		value: d,
		onChange: t,
		collectionId: a,
		className: J.categoryTreeInput,
		label: s,
		required: o,
		disabled: l,
		currentCategoryId: r,
		disabledCategoryIds: i,
		placeholder: c ?? (n ? "Select a parent" : "Select a parent category"),
		withCollectionOption: n
	}) : /* @__PURE__ */ P(T, {
		disabled: !0,
		searchable: !0,
		label: s,
		required: o,
		placeholder: c ?? "Select parent category",
		input: {
			name: e?.id || "Collection",
			value: e?.id || "collection",
			onChange: () => {}
		}
	});
};
// ../management-common/src/components/draftFiling.tsx
function X({ collections: e, collectionsLoading: t = !1, hasMoreCollections: n = !1, onLoadMoreCollections: r, collectionId: i, categoryId: a, onChange: o, isSaving: s = !1 }) {
	let c = t || s, l = a ? {
		__typename: "Category",
		id: a
	} : void 0;
	return /* @__PURE__ */ P(x, {
		width: "320px",
		padding: "300",
		background: "neutral.000",
		borderRadius: "100",
		children: /* @__PURE__ */ F(E, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ P(T, {
				label: "Collection",
				required: !0,
				disabled: c,
				placeholder: "Select a collection",
				input: {
					name: "draftFilingCollection",
					value: i ? [i] : [],
					onChange: (e) => {
						e && o({
							collectionId: e,
							categoryId: null
						});
					}
				},
				items: [...e],
				pagination: {
					infinite: !0,
					nextEnable: n,
					previousEnable: !1,
					onNext: r
				}
			}), /* @__PURE__ */ P(Y, {
				value: l,
				onChange: (e) => o({ categoryId: e.id }),
				withCollectionOption: !1,
				currentCategoryId: void 0,
				collectionId: i || void 0,
				required: !0,
				disabled: c,
				label: "Category",
				placeholder: "Select a category"
			})]
		})
	});
}
var Z = {
	row: "_row_wi8sj_2",
	titleButton: "_titleButton_wi8sj_23",
	rowSelected: "_rowSelected_wi8sj_33"
}, Q = { lock: "_lock_f8h2d_1" }, ee = {
	[s.NewArticle]: "New article",
	[s.ArticleUpdate]: "Article update"
}, te = {
	[s.NewArticle]: "plus",
	[s.ArticleUpdate]: "pen"
};
function ne({ type: e, internalOnly: t = !1 }) {
	return /* @__PURE__ */ F(E, {
		alignItems: "center",
		gap: "100",
		children: [/* @__PURE__ */ P(b, {
			variant: "primary",
			size: "small",
			icon: te[e],
			children: ee[e]
		}), t && /* @__PURE__ */ P(N, {
			content: "Internal only",
			wrapProps: { className: Q.lock },
			children: /* @__PURE__ */ P(D, {
				name: "lock",
				size: 16,
				"aria-label": "Internal only"
			})
		})]
	});
}
// ../management-common/src/components/suggestionRow/suggestionRow.tsx
var re = I(function({ suggestion: e, isSelected: t, onSelect: n }, r) {
	let { type: i, internalOnly: a, title: o, summary: s, conversations: c, initiatedBy: l } = e, u = [e.collectionName, e.categoryName].filter(Boolean).join(" · ");
	return /* @__PURE__ */ P("li", {
		ref: r,
		className: z(Z.row, { [Z.rowSelected]: t }),
		onClick: n,
		children: /* @__PURE__ */ F(E, {
			flexDirection: "column",
			gap: "200",
			children: [
				/* @__PURE__ */ P(x, {
					margin: "0 0 100",
					children: /* @__PURE__ */ P(ne, {
						type: i,
						internalOnly: a
					})
				}),
				/* @__PURE__ */ P("button", {
					type: "button",
					className: Z.titleButton,
					"aria-current": t ? "true" : void 0,
					children: /* @__PURE__ */ P(j.Paragraph, {
						as: "span",
						variant: "2",
						children: /* @__PURE__ */ P("strong", { children: o })
					})
				}),
				/* @__PURE__ */ P(j.Paragraph, {
					variant: "4",
					subdued: !0,
					clamp: 2,
					children: s
				}),
				u && /* @__PURE__ */ P(j.Paragraph, {
					variant: "3",
					subdued: !0,
					children: u
				}),
				/* @__PURE__ */ F(E, {
					alignItems: "center",
					justifyContent: "space-between",
					gap: "200",
					margin: "100 0 0",
					children: [/* @__PURE__ */ F(E, {
						alignItems: "center",
						gap: "100",
						children: [/* @__PURE__ */ P(f, { conversations: c }), l && /* @__PURE__ */ P(N, {
							content: `Initiated by: ${l.name}`,
							children: /* @__PURE__ */ P(y, {
								size: "24",
								user: {
									name: l.name,
									email: l.email,
									avatar_url: l.avatarUrl
								}
							})
						})]
					}), /* @__PURE__ */ P(j.Paragraph, {
						variant: "4",
						subdued: !0,
						children: /* @__PURE__ */ P(M, {
							time: e.activityAt / 1e3,
							relative: !0,
							refreshRate: 6e4
						})
					})]
				})
			]
		})
	});
}), ie = {
	"&amp;": "&",
	"&lt;": "<",
	"&gt;": ">",
	"&quot;": "\"",
	"&apos;": "'",
	"&nbsp;": " "
};
function ae(e) {
	let t = ie[e.toLowerCase()];
	if (t) return t;
	let n = /^&#(x)?([0-9a-f]+);$/i.exec(e);
	if (n) {
		let e = parseInt(n[2], n[1] ? 16 : 10);
		if (Number.isFinite(e) && e > 0 && e <= 1114111 && !(e >= 55296 && e <= 57343)) return String.fromCodePoint(e);
	}
	return e;
}
function oe(e, t = 200) {
	let n = e.replace(/<\/(p|div|h[1-6]|li|tr)>/gi, " ").replace(/<br\s*\/?>/gi, " ").replace(/<[^>]*>/g, "").replace(/&[a-z]+;|&#x?[0-9a-f]+;/gi, ae).replace(/\s+/g, " ").trim();
	if (n.length <= t) return n;
	let r = n.slice(0, t), i = r.lastIndexOf(" ");
	return `${r.slice(0, i > 0 ? i : t)}…`;
}
var $ = {
	modal: "_modal_1rykg_54",
	body: "_body_1rykg_60",
	scroll: "_scroll_1rykg_66",
	articlePreview: "_articlePreview_1rykg_73",
	footer: "_footer_1rykg_79",
	newArticleChip: "_newArticleChip_1rykg_85",
	panes: "_panes_1rykg_90",
	list: "_list_1rykg_95",
	rows: "_rows_1rykg_100"
};
// src/components/Modals/useAiDraftEditor.tsx
function se({ initialDraft: e, conversationId: i, onChange: a, onDiscarded: o }) {
	let { errorNotify: s } = h(), u = r(), [d, { loading: f }] = c({ client: u }), [p, { loading: m }] = n({
		client: u,
		refetchQueries: [l]
	}), g = V("knowledge.content:w"), [_, v] = R(e), [y, b] = R(""), x = "multiple-conversations";
	async function S(e, t) {
		try {
			let n = await d({ variables: {
				id: _.id,
				...e
			} });
			n.data?.aiDraftUpdate && (v(n.data.aiDraftUpdate), a(n.data.aiDraftUpdate), t?.());
		} catch (e) {
			s({ text: e?.message || "Something went wrong" });
		}
	}
	async function C(e) {
		e && (B.conversationArticleDraftImprovementRequested({
			conversationId: i,
			collectionId: _.collectionId || "",
			languageCode: _.languageId,
			draftSource: x
		}), await S({ feedback: e }, () => B.conversationArticleDraftImprovementResponseReceived({
			conversationId: i,
			collectionId: _.collectionId || "",
			languageCode: _.languageId,
			draftSource: x
		})));
	}
	async function w() {
		try {
			await p({ variables: { id: _.id } }), o();
		} catch (e) {
			s({ text: e?.message || "Something went wrong" });
		}
	}
	return {
		draft: _,
		improveInput: y,
		setImproveInput: b,
		onImproveDraft: C,
		onChangePlacement: S,
		onDiscardDraft: w,
		canDiscardDraft: g || !!_.initiatedBy && _.initiatedBy.id === t(),
		isGenerating: f,
		isDiscarding: m
	};
}
// src/components/Modals/multiConversationDraftModal.tsx
function ce(e, t) {
	return {
		id: e.id,
		type: e.type,
		internalOnly: e.internalOnly,
		title: e.title,
		summary: e.summary?.trim() || oe(e.htmlContent),
		collectionName: e.collectionId ? t.get(e.collectionId) : void 0,
		categoryName: void 0,
		conversations: [{
			csid: e.initiatedFromConversation,
			isInitiating: !0
		}, ...e.referencedConversationIds.filter((t) => t !== e.initiatedFromConversation).map((e) => ({ csid: e }))],
		initiatedBy: e.initiatedBy?.name ? {
			name: e.initiatedBy.name,
			email: e.initiatedBy.email ?? void 0,
			avatarUrl: e.initiatedBy.avatarUrl ?? void 0
		} : void 0,
		activityAt: e.modifiedAt ?? e.createdAt
	};
}
function le({ drafts: t, conversationId: n }) {
	let { hideModal: r } = e(), [i, a] = R(t), [o, s] = R(t[0]?.id), { data: c, loading: l } = u(), d = L(() => new Map((c?.collections.results ?? []).map((e) => [e.id, e.title])), [c]), f = i.find((e) => e.id === o) ?? i[0], p = (e) => a((t) => t.map((t) => t.id === e.id ? e : t)), m = (e) => {
		let t = i.filter((t) => t.id !== e);
		if (t.length === 0) {
			r();
			return;
		}
		let n = i.findIndex((t) => t.id === e);
		a(t), e === f?.id && s(t[Math.min(n, t.length - 1)].id);
	};
	return /* @__PURE__ */ F(O, {
		isOpen: !0,
		onClose: r,
		allowEscClose: !1,
		className: $.modal,
		children: [/* @__PURE__ */ P(A, {
			title: "AI drafts",
			onClose: r
		}), /* @__PURE__ */ P(E, {
			flexDirection: "column",
			className: $.body,
			children: /* @__PURE__ */ F(E, {
				flex: "1",
				minHeight: "0",
				className: $.panes,
				children: [/* @__PURE__ */ P(E, {
					flexDirection: "column",
					flex: "0 0 auto",
					width: "332px",
					className: $.list,
					children: /* @__PURE__ */ P(x, {
						as: "ul",
						margin: "0",
						padding: "0",
						className: $.rows,
						"aria-label": "AI drafts from this conversation",
						children: i.map((e) => /* @__PURE__ */ P(re, {
							suggestion: ce(e, d),
							isSelected: e.id === f?.id,
							onSelect: () => s(e.id)
						}, e.id))
					})
				}), f && /* @__PURE__ */ P(ue, {
					draft: f,
					conversationId: n,
					collectionsData: c,
					collectionsLoading: l,
					onChange: p,
					onDiscarded: () => m(f.id)
				}, f.id)]
			})
		})]
	});
}
function ue({ draft: e, conversationId: t, collectionsData: n, collectionsLoading: a, onChange: s, onDiscarded: c }) {
	let { currentQueueId: l } = i(o), [u, h] = R(!1), _ = se({
		initialDraft: e,
		conversationId: t,
		onChange: s,
		onDiscarded: c
	}), { draft: v } = _, y = r(), b = L(() => (n?.collections.results ?? []).filter((e) => (v.possibleCollectionIds.length ? v.possibleCollectionIds.includes(e.id) : e.linkedResources.some((e) => e.id === l)) || e.id === v.collectionId).map((e) => ({
		id: e.id,
		name: e.title
	})), [
		n,
		l,
		v.possibleCollectionIds,
		v.collectionId
	]), T = L(() => b.find((e) => e.id === v.collectionId)?.name || "", [b, v.collectionId]), { data: O } = d({
		client: y,
		variables: { collectionId: v.collectionId || "" },
		skip: !v.collectionId
	}), A = [T, L(() => !v.collectionId || !v.categoryId ? "" : W({
		categories: O?.collection?.categories || [],
		collectionId: v.collectionId,
		withCollectionOption: !1,
		currentCategoryId: void 0,
		disabledCategoryIds: []
	}).listItems.find((e) => e.id === v.categoryId)?.name.trim() || "", [
		O,
		v.categoryId,
		v.collectionId
	])].filter(Boolean).join(" · "), M = L(() => Array.from(/* @__PURE__ */ new Set([t, ...v.referencedConversationIds])).map((e) => ({ csid: e })), [t, v.referencedConversationIds]), I = _.isGenerating || _.isDiscarding, z = /* @__PURE__ */ F(E, {
		flexDirection: "column",
		flex: "0 0 auto",
		gap: "200",
		margin: "400 500 300",
		padding: "300 400",
		background: "purple.100",
		borderWidth: "100",
		borderColor: "purple.300",
		borderRadius: "100",
		children: [
			/* @__PURE__ */ F(E, {
				justifyContent: "space-between",
				alignItems: "flex-start",
				gap: "200",
				children: [/* @__PURE__ */ F(E, {
					gap: "100",
					children: [/* @__PURE__ */ P(C, {
						noBorder: !0,
						className: $.newArticleChip,
						children: "New article"
					}), v.internalOnly && /* @__PURE__ */ P(C, {
						noBorder: !0,
						className: $.newArticleChip,
						children: /* @__PURE__ */ F(E, {
							alignItems: "center",
							gap: "100",
							children: [/* @__PURE__ */ P(D, {
								name: "lock",
								size: 16
							}), "Internal only"]
						})
					})]
				}), /* @__PURE__ */ P(f, { conversations: M })]
			}),
			/* @__PURE__ */ P(j.Heading, {
				variant: "heading-1",
				children: v.title
			}),
			/* @__PURE__ */ F(j.Paragraph, {
				variant: "3",
				color: "secondary",
				children: ["Initiated by ", v.initiatedBy?.name || "AI"]
			}),
			/* @__PURE__ */ F(E, {
				alignItems: "center",
				gap: "100",
				children: [/* @__PURE__ */ P(j.Paragraph, {
					variant: "3",
					color: "secondary",
					children: A
				}), /* @__PURE__ */ P(w, {
					icon: "pen",
					noArrow: !0,
					fixed: !0,
					buttonProps: {
						variant: "tertiary",
						"aria-label": "Change where this draft is filed",
						disabled: I
					},
					show: u,
					onToggle: h,
					dropdown: /* @__PURE__ */ P(g, {
						client: y,
						children: /* @__PURE__ */ P(X, {
							collections: b,
							collectionsLoading: a,
							collectionId: v.collectionId,
							categoryId: v.categoryId,
							onChange: _.onChangePlacement,
							isSaving: I
						})
					})
				})]
			})
		]
	});
	return /* @__PURE__ */ F(E, {
		flexDirection: "column",
		flex: "1",
		minWidth: "0",
		minHeight: "0",
		children: [/* @__PURE__ */ F(x, {
			flex: "1",
			minHeight: "0",
			className: $.scroll,
			children: [z, /* @__PURE__ */ P(m, {
				articleContent: v.htmlContent,
				className: $.articlePreview
			})]
		}), /* @__PURE__ */ F(k, {
			className: $.footer,
			children: [/* @__PURE__ */ P(p, {
				value: _.improveInput,
				onChange: _.setImproveInput,
				onSubmit: _.onImproveDraft,
				isGenerating: _.isGenerating,
				isSaving: _.isDiscarding
			}), /* @__PURE__ */ P(x, {
				padding: "400 500",
				children: /* @__PURE__ */ P(E, {
					justifyContent: "flex-end",
					children: /* @__PURE__ */ P(N, {
						content: "Only the agent who asked for this draft can delete it",
						disabled: _.canDiscardDraft,
						wrap: "div",
						children: /* @__PURE__ */ P(S, {
							variant: "secondary",
							onClick: _.onDiscardDraft,
							disabled: I || !_.canDiscardDraft,
							children: "Discard Draft"
						})
					})
				})
			})]
		})]
	});
}
export { le as MultiConversationDraftModal };

//# sourceMappingURL=multiConversationDraftModal-7SPWwp0f.js.map